import React from "react";

const QueryString = () => {
  return <div>QueryString</div>;
};

export default QueryString;
